// 1. import createPortal
import ReactDOM from 'react-dom';
import './Overlay.css';

export interface OverlayProps {
    children?: any;
    onclick?(): void;
    usePortal?: boolean; // Add prop back, default to true
}

const doNothing = () => {};

export const Overlay = (props: OverlayProps) => {
    const overlayContent = (
        <div className='overlay' onClick={props.onclick ?? doNothing} style={{ margin: 0 }}>
            {props.children}
        </div>
    );

    if (props.usePortal) {
        const portalTarget = typeof window !== 'undefined' ? document.body : null;
        return portalTarget ? ReactDOM.createPortal(overlayContent, portalTarget) : null;
    } else {
        return overlayContent;
    }
};
